import {useFetch} from "../../../../hooks/useFetch";
import {Col, Collapse, Row, Spin} from "antd";
import {BulletText, InfoLink} from "../markerStyles";
import {InfoCircleOutlined} from "@ant-design/icons";
import {formatPhoneNumber, getConstant, isConstantExist} from "../../../../utils/helpers";
import {courierStatuses} from "../../../../constants/constants";
import moment from "moment/moment";
import React, {memo, useMemo} from "react";
import {useStore} from "../../../../hooks/useStore";
import {t} from "i18next";
import styled from "styled-components";
import {useHistory} from "react-router-dom";

const CourierContentComponent = ({courier, courierStatus, delivery}) => {
    const stores = useStore();
    const history = useHistory();
    const [courierInfoLoading, courierInfo] = useFetch({
        defaultDataValue: undefined,
        fetchFn: stores.courierStore.getCourierInfo.bind(null, {
            courierId: courier._id
        }),
        dependencies: [courier._id]
    });
    const courierShift = useMemo(() => courierInfo?.poolShift ?? courierInfo?.dedicatedShift, [
        courierInfo
    ]);

    return (
        <Spin spinning={courierInfoLoading}>
            <Collapse defaultActiveKey={[1]} bordered={false} accordion>
                <Collapse.Panel
                    header={courier.fullname}
                    key="1"
                    extra={
                        stores.meStore.checkRole("courierDetail") && (
                            <InfoLink
                                to={{
                                    pathname: "/couriers/" + courier._id
                                }}
                            >
                                <InfoCircleOutlined />
                            </InfoLink>
                        )
                    }
                >
                    <Row gutter={10}>
                        <Col>
                            <BulletText>{formatPhoneNumber(courier.cellPhone)}</BulletText>
                            <BulletText>
                                {isConstantExist(courierStatuses, courierStatus)
                                    ? t(
                                          getConstant(courierStatuses, courierStatus)
                                              .translation_key,
                                          {
                                              ns: "courierStatuses"
                                          }
                                      )
                                    : "-"}
                            </BulletText>
                            {courierShift?.name && (
                                <BulletText>
                                    {t(
                                        courierShift.type === "pool"
                                            ? "courier.poolName"
                                            : "courier.dedicatedShiftName",
                                        {ns: "courierMapTab"}
                                    )}
                                    : <div style={{display: "contents"}} onClick={() => {
                                        if (courierShift.type === "pool") {
                                            history.push(`/pools/courier-shifts?poolId=${courierShift.poolId}&date=${moment().format("YYYY-MM-DD")}&courierId=${courier._id}&courierShiftSelectionCount=all`);
                                        } else {
                                            history.push(`/shift-management`);
                                        }
                                    }}>
                                        <ClickableSpan>{courierShift?.name}</ClickableSpan>
                                    </div>
                                </BulletText>
                            )}
                            {courierShift?.isFuture !== undefined && (
                                <BulletText>
                                    {t("courier.shiftFuture.title", {ns: "courierMapTab"})}:{" "}
                                    {courierShift?.isFuture ? t("courier.shiftFuture.notStarted", {ns: "courierMapTab"}) : t("courier.shiftFuture.started", {ns: "courierMapTab"})}
                                </BulletText>
                            )}
                            {courierShift?.shiftStart && (
                                <BulletText>
                                    {t("courier.shiftTime", {ns: "courierMapTab"})}:{" "}
                                    {moment(courierShift?.shiftStart).format("HH:mm")} -{" "}
                                    {moment(courierShift?.shiftEnd).format("HH:mm")}
                                </BulletText>
                            )}
                        </Col>
                    </Row>
                </Collapse.Panel>
                {delivery && (
                    <Collapse.Panel
                        header={t("fields.order", {ns: "common"})}
                        key="2"
                        extra={
                            stores.meStore.checkRole("orderDetail") && (
                                <InfoCircleOutlined
                                    onClick={() => history.push("/orders/" + delivery._id)}
                                />
                            )
                        }
                    >
                        {delivery.pickupInfos
                            .sort((prev, curr) => prev.index - curr.index)
                            .map((pickup, i) => (
                                <React.Fragment key={i}>
                                    <BulletText>{pickup.name}</BulletText>
                                </React.Fragment>
                            ))}
                    </Collapse.Panel>
                )}
            </Collapse>
        </Spin>
    );
};
const ClickableSpan = styled.span`
    cursor: pointer;
    text-decoration: underline;
`;

export const CourierContent = memo(CourierContentComponent);
